import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import './tax-info-view.css'

let myToken = localStorage.getItem('token')
let myHeader = {
    headers: { Authorization: `Bearer ${myToken}` }
}

const TaxInfoView = () => {
    const [timesheets, setTimesheets] = React.useState([])
    const [timesheetsForTheYear, setTimesheetsForTheYear] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [teacherProfiles, setTeacherProfiles] = React.useState([])
    const [totals, setTotals] = React.useState({'mma': 0, 'lsma':0, 'tma': 0, 'mor': 0, 'psma': 0})
    const [year, setYear] = React.useState('2022')
    const schools = ['mma', 'lsma', 'tma', 'mor', 'psma']
    React.useEffect(() => {
        axios.get(`${baseUrl}/all-timesheets-year/2022`, myHeader)
        .then((res) => setTimesheets(res.data))
        .catch((err) => console.log(err))
        axios.get(`${baseUrl}/initialadminrequest`, myHeader)
        .then((res) => setTeacherProfiles(res.data))
        .catch((err) => console.log(err))
    }, [])

    React.useEffect(() => {
        console.log(teacherProfiles)
    }, [teacherProfiles])

    React.useEffect(() => {
        timesheets.length > 0 && filterTimesheets()
    }, [timesheets, year])

    React.useEffect(() => {
        let teacherList = []
        let teacherObj = {}
        let schoolList = []
        for(let i = 0; i < timesheetsForTheYear.length; i++) {
            if(teacherObj[timesheetsForTheYear[i].teacherName]) {

            } else {
                let tempTeach = {name: timesheetsForTheYear[i].teacherName, total: ifTheyHaveTurnedInTheirTimesheetCalculatePay(timesheetsForTheYear[i].teacherId), school: timesheetsForTheYear[i].school}
                teacherList.push(tempTeach)
                teacherObj[timesheetsForTheYear[i].teacherName] = true
            }
        }
        let ok = teacherList.sort((a, b) => parseInt(b.total) - parseInt(a.total))
        let fakeTotals = {'mma': 0, 'lsma':0, 'tma': 0, 'mor': 0, 'psma': 0}
        for(let i = 0; i < ok.length; i++) {
            fakeTotals[ok[i].school] = fakeTotals[ok[i].school] + ok[i].total
        }
        setTotals({...fakeTotals})
        setTeachers([...ok])
    }, [timesheetsForTheYear])

    const filterTimesheets = () => {
        let correctSheets = []
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].monthYear === `December/${parseInt(year) - 1}`) {
                correctSheets.push(timesheets[i])
            } else if (timesheets[i].year === parseInt(year) && timesheets[i].monthYear !== `December/${year}`) {
                correctSheets.push(timesheets[i])
            }
        }
        console.log(correctSheets)
        setTimesheetsForTheYear([...correctSheets])
    }

    const ifTheyHaveTurnedInTheirTimesheetCalculatePay = (teacherId) => {
        let arrayOfSheets = []
        for(let i = 0; i < timesheetsForTheYear.length; i++) {
            if(timesheetsForTheYear[i].teacherId === teacherId) {
                arrayOfSheets.push(timesheetsForTheYear[i])
            }
        }
        return calculateEstimatedPay(arrayOfSheets)
    }

    const calculateEstimatedPay = (arrayOfSheets) => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < arrayOfSheets.length; i++) {
            let theTimesheet = arrayOfSheets[i]
            if(theTimesheet.teacherName === 'Emma Myers') {
                console.log(arrayOfSheets)
            }
            for(let i = 0; i < theTimesheet.families.length; i++) {
                let fam = theTimesheet.families[i]
                for(let i = 0; i < fam.lessons.length; i++) {
                    minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
                }
                for(let i = 0; i < fam.cancellations.length; i++) {
                    if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                        minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                    }
                }
                for(let i = 0; i < fam.extras.length; i++) {
                    allExtras = Number(allExtras) + Number(fam.extras[i].amount)
                }
            }
        }
        return ((minutesTaught/60) * Number(arrayOfSheets[0].teacherRate)) + allExtras
    }

    const csvEscape = (value) => {
        if (value == null) return ''
        const stringValue = String(value)
        if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
            return `"${stringValue.replace(/"/g, '""')}"`
        }
        return stringValue
    }

    const handleCreateCsv = () => {
        if (!teachers.length) return
        const header = ['School', 'Teacher Name', 'Amount', 'Address', 'Email']
        const rows = teachers
            .filter((teacher) => Number(teacher.total) > 599)
            .map((teacher) => {
                const profile = teacherProfiles.find((entry) => entry.Name === teacher.name)
                const address = profile?.Address
                    ? `${profile.Address.StreetAddress || ''} ${profile.Address.City || ''} ${profile.Address.State || ''} ${profile.Address.Zip || ''}`.trim()
                    : ''
                const email = profile?.Email || ''
                return [
                    teacher.school?.toUpperCase() || '',
                    teacher.name || '',
                    Number(teacher.total).toFixed(2),
                    address,
                    email
                ]
            })
        const csv = [header, ...rows]
            .map((row) => row.map(csvEscape).join(','))
            .join('\n')
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `tax-info-${year}.csv`
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(url)
    }




    return(
        <div className='tax-info-view__wrapper'>
            <div>
                <h3>Choose the Yearz:</h3>
                <select className='tax-info-view__year-selector' value={year} onChange={(e) => setYear(e.target.value)}>
                    <option value={'2021'}>2021</option>
                    <option value={'2022'}>2022</option>
                    <option value={'2023'}>2023</option>
                    <option value={'2024'}>2024</option>
                    <option value={'2025'}>2025</option>
                    <option value={'2026'}>2026</option>
                    <option value={'2027'}>2027</option>
                    <option value={'2028'}>2028</option>
                    <option value={'2029'}>2029</option>
                    <option value={'2030'}>2030</option>
                </select>
                <button
                    type='button'
                    className='tax-info-view__csv-button'
                    onClick={handleCreateCsv}
                    disabled={!teachers.length}
                >
                    Create CSV
                </button>
            </div>
            {schools.map((school) => (
                <div className='tax-info-view__columns'>
                    <h2>{school.toUpperCase()}</h2>
                    {teachers.map((teacher) => (
                        teacher.school === school && 
                        <div>
                            <div className='tax-info-name' style={teacher.total > 599 ? {color: 'green'} : {color: 'black'}}>{teacher.name}</div>
                            <div className='tax-info-charge'>${teacher.total}</div>
                            {teacherProfiles.map((profile) => profile.Name === teacher.name && (
                              <div className='tax-info-teacher-address'>{profile.Address.StreetAddress} {profile.Address.City} {profile.Address.State} {profile.Address.Zip}</div>  
                            ))}
                        </div>
                    ))}
                    <div className='tax-info-view__totals'>${totals[school]}</div>
                </div>
            ))}
        </div>
    )
}
export default TaxInfoView
